// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YvvPzWyLsaXxB2 {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
}
.u0zeklawIGE8oq {
  display: flex;
  justify-content: center;
}
.MfkyQLXP6h0a_e {
  flex: 1 1 auto;
  min-height: calc(100vh - 80px);
  padding-bottom: var(--ds-space-400, 32px);
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
}
.pAykKbK7EqthDB {
  display: flex;
  justify-content: center;
  padding: var(--ds-space-400, 32px);
}
.wEPol2hQtFwTvb {
  font-style: italic;
}
.RQF9Vglzhh6IfE {
  flex-grow: 1;
  min-width: 320px;
  max-width: 800px;
  padding: var(--ds-space-400, 32px);
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 4px;
  background-color: var(--ds-surface, #ffffff);
}
.r5nqXmAGVzzKZf {
  display: flex;
  align-items: center;
  justify-content: center;
}
.PCEl6axTAy59Ta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--ds-space-300, 24px);
  padding-bottom: var(--ds-space-200, 16px);
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.PCEl6axTAy59Ta .MBMIx1PTaDM0Un {
  margin: var(--ds-space-150, 12px) var(--ds-space-0, 0) var(--ds-space-0, 0);
}
.q7ZExcQMr_DFMl {
  padding-top: var(--ds-space-200, 16px);
  border-top: 1px solid var(--ds-border, #091e4224);
}
.q7ZExcQMr_DFMl button {
  margin-left: var(--ds-space-100, 8px);
}
.PVKQ0DoEU7vohC {
  display: flex;
  justify-content: flex-end;
}
@media only screen and (max-width: 900px) {
  .RQF9Vglzhh6IfE {
    padding: var(--ds-space-200, 16px);
  }
}
.Wzh97Vc0O6n0uW {
  width: 480px;
}
.c84KiX3A7dV6CZ {
  display: flex;
  margin: var(--ds-space-200, 16px) var(--ds-space-0, 0);
}
.c84KiX3A7dV6CZ label {
  margin: var(--ds-space-0, 0);
}
.q7ZExcQMr_DFMl a {
  text-decoration: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexRowWrap": `YvvPzWyLsaXxB2`,
	"flexAndCenter": `u0zeklawIGE8oq`,
	"body": `MfkyQLXP6h0a_e`,
	"navigationAndContent": `pAykKbK7EqthDB`,
	"learnMoreSubtle": `wEPol2hQtFwTvb`,
	"content": `RQF9Vglzhh6IfE`,
	"spinnerContainer": `r5nqXmAGVzzKZf`,
	"header": `PCEl6axTAy59Ta`,
	"title": `MBMIx1PTaDM0Un`,
	"footer": `q7ZExcQMr_DFMl`,
	"formFooter": `PVKQ0DoEU7vohC`,
	"developerAgreement": `Wzh97Vc0O6n0uW`,
	"agreeCheckContainer": `c84KiX3A7dV6CZ`
};
export default ___CSS_LOADER_EXPORT___;
